import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { Box, CardMedia, Chip, Divider, Grid, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography, IconButton, Tooltip } from '@mui/material';
import Colors from '../../../Assets/Styles/Colors';
import { baseUrl } from '../../../../axios';
import moment from 'moment';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { KeyboardArrowLeft } from '@mui/icons-material';

const tableHead = ["Name ", "Applied Date", "Job", "Category", "Job Status"];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function ProposalsDetails() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const { state } = useLocation();
  console.log(state);

  return (
    <Fragment>
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Proposal Details
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["User Details"]} />
          </Grid>
        </Grid>
        <Box
          component={Paper}
          sx={{
            borderRadius: "4px",
            boxShadow: "0px 0px 10px 2px #e3e3e3",
            mt: "20px"
          }}
        >
          <Grid container alignItems={"center"}>
            <Grid item md={3} sx={{ borderRight: "1px solid #E0E0E0" }}>
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "15px",
                  p: "16px",
                }}
              >
                <Box component={Paper} sx={{
                  borderRadius: "50%", width: "180px",
                  height: "180px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0px 0px 10px 2px #e3e3e3"
                }}>
                  <CardMedia
                    component={"img"}
                    src={baseUrl + state?.submittedBy?.image}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item md={9}>
              <Grid container justifyContent={"space-between"} sx={{ height: "100%" }}>
                <Grid item md={12}>
                  <Box sx={{ height: "100%", display: "flex", alignItems: "center", }}>
                    <Box sx={{ p: "20px", width: "100%", display: "flex", flexDirection: "column", gap: "30px" }}>
                      <Box>
                        <Typography sx={{ fontWeight: 600, fontSize: "20px" }}>
                          Submitted By:
                        </Typography>
                      </Box>
                      <Grid container spacing={2} rowSpacing={3}>
                        <Grid item md={4}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Name:</Typography>
                            <Typography variant={"subtitle1"}>{state?.submittedBy?.name}</Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Email:</Typography>
                            <Tooltip title={state?.submittedBy?.email} arrow>
                              <Typography
                                variant={"subtitle1"}
                                sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
                              >
                                {state?.submittedBy?.email}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Grid>
                        <Grid item md={4}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Phone:</Typography>
                            <Typography variant={"subtitle1"}>{state?.submittedBy?.phone_Number}</Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Country:</Typography>
                            <Typography variant={"subtitle1"}>{state?.submittedBy?.country ?? "-"}</Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>City:</Typography>
                            <Typography variant={"subtitle1"}>{state?.submittedBy?.city ?? "-"}</Typography>
                          </Box>
                        </Grid>
                        <Grid item md={4}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>State:</Typography>
                            <Typography variant={"subtitle1"}>{state?.submittedBy?.state ?? "-"}</Typography>
                          </Box>
                        </Grid>
                        {state?.submittedBy?.roles == "INDIVIDUAL" ? (
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>
                                Industry:
                              </Typography>
                              <Typography variant={"subtitle1"}>
                                {state?.submittedBy?.additional?.industry?.name}
                              </Typography>
                            </Box>
                          </Grid>
                        ) : state?.submittedBy?.roles == "AGENCY" ? (
                          <Fragment>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>
                                  Service:
                                </Typography>
                                <Typography variant={"subtitle1"}>
                                  {state?.submittedBy?.additional?.services?.name}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>
                                  Industry:
                                </Typography>
                                <Typography variant={"subtitle1"}>
                                  {state?.submittedBy?.additional?.industry?.name}
                                </Typography>
                              </Box>
                            </Grid>
                          </Fragment>
                        ) : <></>}
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            mt: "8px",
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Proposal Details" {...a11yProps(0)} />
              <Tab label="Ad Details" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Box sx={{ mt: "20px" }}>
              <Box
                component={Paper}
                sx={{
                  borderRadius: "4px",
                  boxShadow: "0px 0px 10px 2px #e3e3e3",
                  mt: "20px"
                }}
              >
                <Grid container>
                  {/* <Grid item md={12} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                      <Box
                        sx={{
                          p: "20px",
                        }}
                      >
                        <Swiper
                          spaceBetween={10}
                          slidesPerView={1}
                          className='mySwiper'
                          onSlideChange={() => console.log('slide change')}
                          onSwiper={(swiper) => console.log(swiper)}
                          modules={[Pagination, Navigation]}
                          navigation
                          pagination={{ clickable: true }}
                        >
                          {state?.adId?.image?.map((img, i) => (
                            <SwiperSlide key={i}>
                              <CardMedia component={"img"} src={baseUrl + img} sx={{ height: "400px", objectFit: "contain", position: "center" }} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </Box>
                    </Grid> */}
                  <Box sx={{ mt: "20px" }}>
                    <Box
                      component={Paper}
                      sx={{
                        borderRadius: "4px",
                        boxShadow: "0px 0px 10px 2px #e3e3e3"
                      }}
                    >
                    </Box>
                  </Box>
                  <Grid item md={12}>
                    <Grid container justifyContent={"space-between"} sx={{ height: "100%" }}>
                      <Grid item md={12}>
                        <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", width: "100%" }}>
                              <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                                Proposal Details:
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Status:</Typography>
                              <Typography variant={"subtitle1"}>
                                <Chip
                                  label={state?.status == true
                                    ? "Hired"
                                    : "Pending"
                                  }
                                  sx={{
                                    backgroundColor: state?.status == true
                                      ? Colors.success + 26
                                      : Colors.danger + 26,
                                    color: state?.status == true
                                      ? Colors.success
                                      : Colors.danger,
                                  }}
                                />
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item md={12}>
                        <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                          <Grid container spacing={2}>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Budget:</Typography>
                                <Typography variant={"subtitle1"}>PKR {state?.budget}</Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Duration:</Typography>
                                <Typography variant={"subtitle1"}>{state?.jobDuration}</Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Applied At:</Typography>
                                <Typography variant={"subtitle1"}>{moment(state?.createdAt).format("DD-MM-YYYY")}</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={12}>
                    <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                      <Box sx={{ display: "flex", width: "100%", gap: "10px", }}>
                        <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Message:</Typography>
                        <Typography variant={"subtitle1"}>{state?.content ?? "-"}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Box sx={{ mt: "20px" }}>
              <Box
                component={Paper}
                sx={{
                  borderRadius: "4px",
                  boxShadow: "0px 0px 10px 2px #e3e3e3"
                }}
              >
                <Grid container>
                  <Grid item md={12} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                    <Box
                      sx={{
                        p: "20px",
                      }}
                    >
                      <Swiper
                        spaceBetween={10}
                        slidesPerView={1}
                        className='mySwiper'
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                        modules={[Pagination, Navigation]}
                        navigation
                        pagination={{ clickable: true }}
                      >
                        {state?.adId?.image?.map((img, i) => (
                          <SwiperSlide key={i}>
                            <CardMedia component={"img"} src={baseUrl + img} sx={{ height: "400px", objectFit: "contain", position: "center" }} />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </Box>
                  </Grid>
                  <Grid item md={12}>
                    <Grid container justifyContent={"space-between"} sx={{ height: "100%" }}>
                      <Grid item md={12}>
                        <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", width: "100%" }}>
                              <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                                Job Details:
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Status:</Typography>
                              <Typography variant={"subtitle1"}>
                                <Chip
                                  label={state?.adId?.isCompleted == true
                                    ? "Completed"
                                    : state?.adId?.isApproved == null
                                      ? "Pending"
                                      : state?.adId?.isApproved == true
                                        ? "Posted"
                                        : "Disapproved"
                                  }
                                  sx={{
                                    backgroundColor: state?.adId?.isCompleted == true
                                      ? Colors.gunMetal
                                      : state?.isApproved == null
                                        ? Colors.danger + 26
                                        : state?.adId?.isApproved == true
                                          ? Colors.success + 26
                                          : Colors.danger + 26,
                                    color: state?.adId?.isCompleted == true
                                      ? Colors.white
                                      : state?.isApproved == null
                                        ? Colors.danger
                                        : state?.adId?.isApproved == true
                                          ? Colors.success
                                          : Colors.danger,
                                  }}
                                />
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item md={12}>
                        <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                          <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                            <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Category:</Typography>
                            <Box sx={{ display: "flex", gap: "8px" }}>
                              {state?.adId?.category.map((item) => <Typography>{item.name}</Typography>)}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item md={12}>
                        <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                          <Grid container spacing={2}>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Title:</Typography>
                                <Typography variant={"subtitle1"}>{state?.adId?.title}</Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Budget:</Typography>
                                <Typography variant={"subtitle1"}>PKR {state?.adId?.budget}</Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Posted By:</Typography>
                                <Typography variant={"subtitle1"}>{state?.adId?.postedBy?.name ?? "-"}</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                      <Grid item md={12}>
                        <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                          <Grid container spacing={2}>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Date of Creation:</Typography>
                                <Typography variant={"subtitle1"}>{moment(state?.adId?.createdAt).format("DD-MM-YYYY")}</Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Valid Till:</Typography>
                                <Typography variant={"subtitle1"}>{moment(state?.adId?.valid_till).format("DD-MM-YYYY")}</Typography>
                              </Box>
                            </Grid>
                            <Grid item md={4}>
                              <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                                <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Duration:</Typography>
                                <Typography variant={"subtitle1"}>{state?.adId?.jobDuration}</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={12}>
                    <Box sx={{ p: "20px", borderBottom: "1px solid #E0E0E0" }}>
                      <Box sx={{ display: "flex", width: "100%", gap: "10px", }}>
                        <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Description:</Typography>
                        <Typography variant={"subtitle1"}>{state?.adId?.description ?? "-"}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </CustomTabPanel>
        </Box>
      </Box>
    </Fragment >
  )
}

export default ProposalsDetails;